import { FunctionComponent } from 'react';
import { Box } from './Box';

type ImageParams = {
  url: string
  alt?: string
  w?: string
}
export const BoxImage: FunctionComponent<ImageParams> = (props) => {
  return (
    <Box w={props.w} style={{display: 'inline-block'}}>
      <img src={props.url} alt={props.alt} width='100%' height='100%' />
    </Box>
  );
}
